import {React} from 'react';
import AppRoute from './routes/AppRoute';


function App() {
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     const message = "Are you sure you want to leave? Any unsaved changes will be lost!";
  //     event.returnValue = message; 
  //     return message;  
  //   };
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  return (
    <div className="App">
      <AppRoute />
    </div>
  );
}

export default App;
